import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseConversationDraftMessage } from 'entities/Conversation'
import { type ConversationMenuStore } from '../store/conversationMenuStore'

export const useEventMessageCreatedDraft = (store: ConversationMenuStore) => {
  const entities = useEntitiesContext()
  const { websocket } = entities
  const handler = (data: IResponseConversationDraftMessage) => {
    store.quickFiltersMenuStore.handleQuickFilterDraftCount({
      conversationId: data.conversation_id,
      isIncrease: true,
    })
  }

  useEffect(() => websocket.on(WebsocketEvent.ClientDraft, handler), [])
}
